"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPDFData = exports.IBasePDFData = exports.IPdfCharge = void 0;
const openapi_1 = require("../../../openapi");
const ICharge_1 = require("../charges/ICharge");
const customers_1 = require("../customers");
const IInvoice_1 = require("./IInvoice");
//TODO move this from commons to sdk
class IAppOrganization {
    orgKey;
    appData;
}
class IPdfOrgData extends IAppOrganization {
    stringCityStateZip;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfOrgData.prototype, "stringCityStateZip", void 0);
class IPdfInvoice extends IInvoice_1.IInvoice {
    stringDate;
    stringDueDate;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfInvoice.prototype, "stringDate", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfInvoice.prototype, "stringDueDate", void 0);
class IPdfCustomer extends customers_1.ICustomer {
    address1;
    address2;
    stringCityStateZip;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfCustomer.prototype, "address1", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfCustomer.prototype, "address2", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfCustomer.prototype, "stringCityStateZip", void 0);
class IPdfCharge extends ICharge_1.ICharge {
    stringConfirmDate;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPdfCharge.prototype, "stringConfirmDate", void 0);
exports.IPdfCharge = IPdfCharge;
class IBasePDFData {
    invoice;
    customer;
    orgData;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'object' })
], IBasePDFData.prototype, "invoice", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'object' })
], IBasePDFData.prototype, "customer", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'object' })
], IBasePDFData.prototype, "orgData", void 0);
exports.IBasePDFData = IBasePDFData;
class IPDFData extends IBasePDFData {
    invoiceSummary;
    invoiceDetail;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'object' })
], IPDFData.prototype, "invoiceSummary", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'object' })
], IPDFData.prototype, "invoiceDetail", void 0);
exports.IPDFData = IPDFData;
